import React, { useEffect, FC } from 'react';
import { useLocation } from 'react-router-dom';
import ym, { YMInitializer } from 'react-yandex-metrika';

import { TrackerProps } from './types';


const trackPage = (page: string) => ym('hit', page);

export const Tracker: FC<TrackerProps> = ({ accountIds, options }) => {
    const location = useLocation();
    useEffect(
        () => trackPage(location.pathname),
        [location.pathname],
    );

    return (
        <YMInitializer
            accounts={accountIds}
            options={{
                defer: true,
                ...options,
            }}
            version='2'
        />
    );
};

export * from './types';
